<form class="app-search-bar" role="search" (submit)="$event.preventDefault(); submit()">
  <div class="search-input-wrapper">
    <i class="fas fa-search search-icon" aria-hidden="true"></i>

    <input
      type="search"
      name="q"
      enterkeyhint="search"
      [attr.aria-label]="placeholder"
      [attr.aria-expanded]="showPanel"
      class="search-input"
      [placeholder]="placeholder"
      [ngModel]="query"
      (ngModelChange)="onInput($event)"
      (focus)="onFocus()"
      [attr.autofocus]="autofocus ? true : null"
      autocomplete="off"
    />

    <button type="button" class="clear-btn" *ngIf="query" (click)="clear()" aria-label="Clear search">
      <i class="fas fa-times"></i>
    </button>

    <button type="submit" class="search-btn" aria-label="Search">
      <i class="fas fa-search"></i>
    </button>
  </div>

  <!-- SUGGESTIONS PANEL: projected live results while typing, recent/trending when empty -->
  <div class="suggestions-panel" *ngIf="showPanel && showSuggestionsPanel && (query ? hasLiveResults : (recentSearches.length || popularSearches.length))">

    <ng-content select="[liveResults]" *ngIf="query"></ng-content>

    <ng-container *ngIf="!query">
      <div class="panel-section" *ngIf="recentSearches.length">
        <div class="panel-section-header">
          <span><i class="fas fa-history"></i> Recent Searches</span>
          <button type="button" class="clear-all-btn" (click)="clearAllRecent($event)">Clear all</button>
        </div>
        <div class="chip-list">
          <span class="chip" *ngFor="let r of recentSearches">
            <button type="button" class="chip-label" (click)="selectChip(r.query)">{{ r.query }}</button>
            <button type="button" class="chip-remove" (click)="removeRecent(r.query, $event)" [attr.aria-label]="'Remove ' + r.query">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="panel-section" *ngIf="popularSearches.length">
        <div class="panel-section-header">
          <span><i class="fas fa-arrow-trend-up" aria-hidden="true"></i> Popular searches</span>
        </div>
        <div class="chip-list">
          <button type="button" class="chip trending" *ngFor="let t of popularSearches" (click)="selectChip(t)">
            {{ t }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</form>
